<script lang="ts">
	import type { PageData } from './$types';
	import theme from 'stores/theme';
	import PageTitle from 'components/LearnPage/PageTitle/PageTitle.svelte';
	import ArticlesSection from 'components/LearnPage/ArticlesSection/ArticlesSection.svelte';
	import KeyTermsSection from 'components/LearnPage/KeyTermsSection/KeyTermsSection.svelte';
	import ArticleFilters from 'components/LearnPage/ArticleFilters/ArticleFilters.svelte';
	import MoreBtn from 'components/LearnPage/MoreBtn/MoreBtn.svelte';
	import { _ } from 'utils/i18/i18n';
	// import SanityNews from 'components/SanityNews/SanityNews.svelte';
	import MetaTags from 'components/MetaTags/MetaTags.svelte';
	import ArticleSearch from 'components/LearnPage/ArticleSearch/ArticleSearch.svelte';
	import Pagination from 'components/Pagination/Pagination.svelte';

	export let data: PageData;

	$: dark = $theme;

	let page = 1;
	let totalPages = data?.pages ?? 0;
	let category = 'all';
	let articles = data?.lastLearnArticles;
	let query = '';

	const handlePageChange = (currentPage: number) => {
		page = currentPage;
		document.body.scrollIntoView({ behavior: 'smooth' });
	};

	const handleCategory = (selectedCategory: string) => {
		category = selectedCategory;
	};

	const handleTotalPages = (totalPagesNumber: number) => {
		totalPages = totalPagesNumber;
	};

	const setArticles = (newArticles) => {
		articles = newArticles;
	};

	const handleQuery = (newQuery: string) => {
		query = newQuery;
	};
</script>

<MetaTags
	title={'Learn | CryptoMarketCap'}
	description={`CryptoMarketCap's blog about crypto. Learn how to crypto.`}
/>

<div class="container" class:dark>
	<PageTitle {dark} />

	<div class="search-wrapper">
		<ArticleSearch {query} {dark} {setArticles} {page} {handleQuery} {handleTotalPages} {category} />
	</div>

	{#key category}
		<div class="filters-wrapper">
			<ArticleFilters {dark} {handleCategory} {category} {handleQuery} {handlePageChange} />
		</div>
	{/key}

	{#if articles.length > 0}
		<div class="articles">
			<ArticlesSection {dark} {articles} />
		</div>
	{:else}
		<div class="no-results" class:dark>
			<p class="title">{$_('learn.noResultsTitle')}</p>
			<p class="subtitle">{$_('learn.noResultsSubtitle')}</p>
		</div>
	{/if}

	{#if totalPages >= 2}
		<Pagination bind:currentPage={page} page="/learn" {dark} totalCount={totalPages} />
	{:else}
		<br />
	{/if}
</div>

<p class="section-title container" class:dark>
	{$_('learn.keyTermTitle')}
</p>
<KeyTermsSection {dark} class={null} keyTerms={data.keyTermArticles} />
<MoreBtn as="link" title={$_('learn.keyTermButton')} linkTo="/learn/glossary" class={null} />

<!-- {#if data?.allNews.length > 0}
	<p class="section-title container" class:dark>
		{$_('learn.newsTitle')}
	</p>

	<SanityNews {dark} newsList={data.allNews} />

	<MoreBtn as="link" title={$_('learn.newsButton')} linkTo="/news" class="bottom" />
{/if} -->

<style lang="scss">
	@import 'learn';
</style>
